import React from 'react';
import { Dialog, FlatButton, RaisedButton } from 'material-ui';

const CreateDraft = ({
  companyType,
  onRequestClose,
  createSingleDraft,
  createTemplateDraft,
  open,
  templateId,
  templateFromDummy,
  createDummyTemplateDraft,
}) => {
  const actions = (() => {
    if (companyType === 'Contractor') {
      return [
        <FlatButton label="cancel" primary onClick={onRequestClose} />,
        <FlatButton label="confirm" secondary onClick={createDummyTemplateDraft} />,
      ];
    }
    return [
      <FlatButton label="cancel" primary onClick={onRequestClose} />,
      <FlatButton label={ templateId ? 'No, edit this contract only' : 'confirm' } secondary onClick={createSingleDraft} />,
      templateId ? <RaisedButton label="Yes, edit template" secondary onClick={createTemplateDraft} /> : undefined,
    ];
  })();
  return (
    <Dialog
      open={open}
      title="EDITING A CONTRACT"
      onRequestClose={onRequestClose}
      actions={actions}
    >
      {
        (() => {
          if (companyType === 'Contractor' && !templateFromDummy) {
            return (
              <div>This contract was created by the supplier.  To maintain the integrity of the rates, we will create a buyer copy of this contract so you can make edits yourself.</div>
            );
          }
          if (templateFromDummy) {
            return (
              <div>Please click CONFIRM if you’d like to edit this contract.</div>
            );
          }
          if (!templateId) {
            return (
              <div>
                <div>Please click CONFIRM if you’d like to edit this contract.</div>
                <br/>
                <i>Note that we will create a new contract draft for you to work on your changes. Unless you publish the changes, your partner will only see their original contract.</i>
              </div>
            );
          }
          return (
            <div>
              <div>This contract was created from a template and sent to multiple buyers. Would you like to edit the template and send updates to all associated buyers?</div>
              <br/>
              <i>Note that we will create a new draft for you to work on your changes. Unless you publish the changes, your partners will only see their original contract.</i>
            </div>
          );
        })()
      }
    </Dialog>
  );
};

export default CreateDraft;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/dialog-create-contract-draft.jsx